/** @jsxImportSource @emotion/react */
import { cx } from '@emotion/css';
import type { FC, ReactNode } from 'react';
import ODSLogo from '../ODSLogo';

type Props = React.ComponentProps<'div'> & {
  className?: string;
  /** Make it smaller or larger */
  width?: string;
  /** Add a subtitle below the logo */
  subTitle?: ReactNode;
  /** Condense the heading */
  condensed?: boolean;
  /** Optional content rendered above the white card. When present, the card's top corners flatten so the banner sits flush. */
  topBanner?: ReactNode;
};

const ODSLoginPortal: FC<Props> = ({
  children,
  className,
  subTitle,
  width = '30rem',
  condensed,
  topBanner,
  ...componentProps
}) => {
  return (
    <div className="bg-bc d-flex w-100 h-100 overflow-y-auto">
      <div className="d-flex align-items-center justify-content-center w-100 h-100">
        <div className="p-4 mw-100 m-auto" css={{ maxWidth: '100%', width }}>
          {topBanner}
          <div
            className={cx(
              'bg-white shadow',
              topBanner ? 'rounded-bottom-4' : 'rounded-4',
              className
            )}
            css={{ width: '100%' }}
          >
            <div
              className={cx(
                'd-flex flex-column gap-2 justify-content-center align-items-center px-3',
                condensed ? 'pt-4 pb-2' : 'pt-5 pb-4 mb-2'
              )}
            >
              <ODSLogo css={{ maxWidth: '100%', height: '2.5rem' }} />
              {!!subTitle && (
                <div className="text-secondary small text-center mt-1">{subTitle}</div>
              )}
            </div>
            <div
              className={cx(className)}
              css={(theme) => ({ ...theme.spacing.px(4), ...theme.spacing.pb(4) })}
              {...componentProps}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ODSLoginPortal;
